import { computed, inject } from 'vue';

import features from '@common/constants/features';

import { useStore } from '@/store';

export const useShowBarcodeScanner = () => {
  const adaptive = inject('adaptive');

  const store = useStore();
  const isScannerFeatureEnabled = computed(() => adaptive.isMobile && store.getters['features/$isFeatureEnabled'](features.BARCODE_SCANNER));
  const isScannerShown = computed(() => store.state.barcodeScanner.isShown);
  const showScanner = (openedFromMenu) => {
    if (isScannerFeatureEnabled.value) {
      store.dispatch('barcodeScanner/show', { openedFromMenu });
    }
  };
  const openedFromMenu = computed(() => store.state.barcodeScanner.openedFromMenu);

  const hideScanner = () => {
    store.dispatch('barcodeScanner/hide');
  };

  return {
    showScanner,
    hideScanner,
    isScannerShown,
    isScannerFeatureEnabled,
    openedFromMenu,
  };
};
